<template>
  <v-row no-gutters>
    <v-col :cols="4">
      <div
       class="text-h6m px-0 pt-3 mb-3"
       style="color:black;"
       :id="id">
        {{headerTitle}}
      </div>
      <slot/>
    </v-col>
    <v-col :cols="4">
      <dd-switch
        class="text-h6m switch-line px-5"
        :label="switchLabel"
        v-bind="computedProps"
        v-on="computedListeners"/>
    </v-col>
    <v-col :cols="4">
      <div class="text-h6l px-5 pt-10"></div>
    </v-col>
  </v-row>
</template>
<script>
import inputMixin from '@/mixins/inputMixins'
import DdSwitch from '@/components/DdSwitch'

/**
 * @file DDv2用スイッチ付きアローヘッダ
 * @namespace components
 */

/**
 * @vue-prop {String} [id=''] - ID
 * @vue-prop {String} [headerTitle=''] - ヘッダータイトル
 * @vue-prop {String} [switchLabel=''] - スイッチラベル
 * @see components.DdSwitch
 * @example
 * <dd-arrow-header-with-switch
 *   v-model="checkValue"
 *   id="string"
 *   headerTitle="string"
 *   switchLabel="string"
 * />
 */
export default {
  name: 'DdArrowHeaderWithSwitch',
  components: {
    DdSwitch
  },
  extends: DdSwitch,
  mixins: [inputMixin],
  props: {
    /**
     * ID
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * 表示ヘッダータイトル
     */
    headerTitle: {
      type: String,
      default: ''
    },
    /**
     * スイッチのラベル
     */
    switchLabel: {
      type: String,
      default: ''
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
  },
  watch: {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.text-h6l {
  position: relative;
  padding-left: 25px;
  font-size:20px
}
.text-h6l:before {
  position: absolute;
  content: '';
  bottom: -12px;
  left: 100%;
  width: 0;
  height: 0;
  border: none;
  border-right: solid 15px transparent;
  border-bottom: solid 15px rgb(47, 117, 181);
}
.text-h6l:after {
  position: absolute;
  content: '';
  bottom: -12px;
  left: 0;
  width: 100%;
  border-bottom: solid 3px rgb(47, 117, 181);
}
.text-h6m{
  position: relative;
  padding-left: 25px;
  color: #333; /*文字の色を変更*/
  font-size: 1.5rem;
  font-weight: 700;
}
.text-h6m:before {
  position: absolute;
  content: '';
  bottom: -4px;
  left: 0;
  width: 100%;
  border-bottom: solid 3px rgb(47, 117, 181);
}
.switch-line{
  margin-top: 0px !important;
  padding-top: 19px !important;
  padding-bottom: 14px !important;
}
.switch-line-divider{
  margin-top:0px !important;
  padding-top:19px !important;
}
</style>
